import { patch } from "../base.ehq.model";
import { serialize } from "./submit-password.serializer";
import { deserialize } from "../base.serializer";

export const submitResetPassword = async (
  token: string,
  baseUrl: string,
  body: unknown
) => {
  try {
    const queryPath = `${baseUrl}/reset_password`;
    const serializedBody = serialize(body);
    const res = await patch(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
